module.exports = __webpack_public_path__ + "static/media/lagga-ihop.1e9d2230.mp3";